import { Heading } from 'components/Heading/Heading';
import { ReactComponent as RemoveCircle } from 'icons/remove-circle.svg';

const DefaultFallback = () => {
  return (
    <div>
      <main>
        <section className="flex flex-col items-center text-center justify-center w-auto mx-auto max-w-[576px] min-h-screen break-words py-8 px-2 lg:text-left lg:items-start lg:px-0">
          <RemoveCircle aria-hidden="true" focusable="false" />

          <Heading as="h1" size="huge" className="my-4 text-[32px]">
            Page Not Found
          </Heading>
          <p className="fontSize-lg marginBottom-sm">
            <span className="marginRight-xs">
              An error occurred. Please restart your payment. If the problem
              persists,
            </span>
            <a href={'https://help.flywire.com/hc/en-us'}>Contact Support</a>.
          </p>
        </section>
      </main>
    </div>
  );
};

export { DefaultFallback };
